<script>
import { mapGetters } from 'vuex';
import wootConstants from 'dashboard/constants/globals';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  data() {
    return {
      helpCenterDocsURL: wootConstants.HELP_CENTER_DOCS_URL,
      upgradeFeature: [
        {
          key: 1,
          title: this.$t('HELP_CENTER.UPGRADE_PAGE.FEATURES.PORTALS.TITLE'),
          icon: 'book-copy',
          description: this.$t(
            'HELP_CENTER.UPGRADE_PAGE.FEATURES.PORTALS.DESCRIPTION'
          ),
        },
        {
          key: 2,
          title: this.$t('HELP_CENTER.UPGRADE_PAGE.FEATURES.LOCALES.TITLE'),
          icon: 'globe-line',
          description: this.$t(
            'HELP_CENTER.UPGRADE_PAGE.FEATURES.LOCALES.DESCRIPTION'
          ),
        },
        {
          key: 3,
          title: this.$t('HELP_CENTER.UPGRADE_PAGE.FEATURES.SEO.TITLE'),
          icon: 'heart-handshake',
          description: this.$t(
            'HELP_CENTER.UPGRADE_PAGE.FEATURES.SEO.DESCRIPTION'
          ),
        },
        {
          key: 4,
          title: this.$t('HELP_CENTER.UPGRADE_PAGE.FEATURES.API.TITLE'),
          icon: 'search-check',
          description: this.$t(
            'HELP_CENTER.UPGRADE_PAGE.FEATURES.API.DESCRIPTION'
          ),
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      isOnChatwootCloud: 'globalConfig/isOnChatwootCloud', // Pending change text
    }),
  },
  methods: {
    openBillingPage() {
      this.$router.push({
        name: 'billing_settings_index',
        params: { accountId: this.accountId },
      });
    },
    openHelpCenterDocs() {
      window.open(this.helpCenterDocsURL, '_blank');
    },
  },
};
</script>

<template>
  <div
    class="flex min-h-screen w-full max-w-full flex-col items-center justify-center gap-10 overflow-auto bg-auth-canvas px-4 py-10 text-auth-text dark:bg-auth-canvas-dark dark:text-auth-text-dark sm:gap-12"
  >
    <div class="flex max-w-3xl flex-col justify-start gap-6 sm:justify-center">
      <div class="flex flex-col items-start gap-3 sm:items-center">
        <h1
          class="mb-2 text-left text-4xl font-semibold tracking-tight text-auth-text dark:text-auth-text-dark sm:text-center sm:text-5xl"
        >
          {{ $t('HELP_CENTER.UPGRADE_PAGE.TITLE') }}
        </h1>
        <p
          class="max-w-2xl text-left text-base font-normal leading-7 text-auth-muted dark:text-auth-muted-dark sm:text-center"
        >
          {{
            isOnChatwootCloud
              ? $t('HELP_CENTER.UPGRADE_PAGE.DESCRIPTION')
              : $t('HELP_CENTER.UPGRADE_PAGE.SELF_HOSTED_DESCRIPTION')
          }}
        </p>
      </div>
      <div
        v-if="isOnChatwootCloud"
        class="flex flex-row items-center justify-start gap-3 sm:justify-center"
      >
        <NextButton
          outline
          :label="$t('HELP_CENTER.UPGRADE_PAGE.BUTTON.LEARN_MORE')"
          class="!rounded-xl !border-auth-border !bg-auth-surface !text-auth-text hover:!bg-auth-soft dark:!border-auth-border-dark dark:!bg-auth-surface-dark dark:!text-auth-text-dark dark:hover:!bg-auth-soft-dark"
          @click="openHelpCenterDocs"
        />
        <NextButton
          :label="$t('HELP_CENTER.UPGRADE_PAGE.BUTTON.UPGRADE')"
          class="!rounded-xl !bg-auth-action !text-white hover:!bg-auth-action-hover dark:!bg-auth-accent dark:!text-auth-brand dark:hover:!bg-auth-accent-hover"
          @click="openBillingPage"
        />
      </div>
    </div>
    <div
      class="grid w-full max-w-3xl grid-cols-1 divide-y divide-auth-border overflow-hidden rounded-xl border border-auth-border bg-auth-surface dark:divide-auth-border-dark dark:border-auth-border-dark dark:bg-auth-surface-dark sm:grid-cols-2 sm:divide-y-0"
    >
      <div
        v-for="feature in upgradeFeature"
        :key="feature.key"
        class="min-w-full border-auth-border p-5 dark:border-auth-border-dark sm:border-b sm:border-e sm:[&:nth-child(even)]:border-e-0 sm:[&:nth-last-child(-n+2)]:border-b-0"
      >
        <div class="flex flex-row gap-3">
          <div>
            <fluent-icon
              :icon="feature.icon"
              icon-lib="lucide"
              :size="26"
              class="mt-px text-auth-action dark:text-auth-accent"
            />
          </div>
          <div>
            <h5
              class="text-base font-semibold text-auth-text dark:text-auth-text-dark"
            >
              {{ feature.title }}
            </h5>
            <p
              class="text-sm leading-6 text-auth-muted dark:text-auth-muted-dark"
            >
              {{ feature.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
